import React, { useState } from 'react';

const UrlModifier = () => {
  // Default URLs (fixed)
  const defaultWebUrl = 'https://www.cvs.com/shop/merch/cmx-bloom?widgetID=123456787&mc=cvscontentpage';
  const defaultAppUrl = 'https://cvs.app?widgetId=q9xm7evj&destinationType=cplp&pageTitle=Mondelez&query=cvscontentpage';

  // Input states
  const [webPath, setWebPath] = useState('cmx-bloom');
  const [webWidgetID, setWebWidgetID] = useState('123456787');
  const [appWidgetID, setAppWidgetID] = useState('q9xm7evj');
  const [appTitle, setAppTitle] = useState('Mondelez');

  // Result URLs
  const [modifiedWebUrl, setModifiedWebUrl] = useState('');
  const [modifiedAppUrl, setModifiedAppUrl] = useState('');

  // Copy helper
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert('Copied to clipboard!');
  };

  // Web URL handler
  const handleWebUpdate = () => {
    const url = new URL(defaultWebUrl);
    const pathParts = url.pathname.split('/');
    pathParts[pathParts.length - 1] = webPath;
    url.pathname = pathParts.join('/');
    url.searchParams.set('widgetID', webWidgetID);
    setModifiedWebUrl(url.toString());
  };

  // App URL handler
  const handleAppUpdate = () => {
    const url = new URL(defaultAppUrl);
    url.searchParams.set('widgetId', appWidgetID);
    url.searchParams.set('pageTitle', appTitle);
    setModifiedAppUrl(url.toString());
  };

  return (
    <>
    <div style={{ maxWidth: '700px', margin: '0 auto', fontFamily: 'Arial' }}>
      <h2>URL Modifier Tool</h2>

      {/* Web URL Section */}
      <div style={{ marginBottom: '30px' }}>
        <h3>Web URL</h3>
        <p><strong>Default:</strong> {defaultWebUrl}</p>

        <label>Path (e.g., cmx-bloom):</label>
        <input
          type="text"
          value={webPath}
          onChange={(e) => setWebPath(e.target.value)}
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <label>WidgetID:</label>
        <input
          type="text"
          value={webWidgetID}
          onChange={(e) => setWebWidgetID(e.target.value)}
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <button onClick={handleWebUpdate}>Update Web URL</button>

        {modifiedWebUrl && (
          <div style={{ marginTop: '10px' }}>
            <strong>Modified Web URL:</strong> 
            <a href={modifiedWebUrl} target="_blank" rel="noopener noreferrer">{modifiedWebUrl}</a>
            <button onClick={() => copyToClipboard(modifiedWebUrl)} style={{ marginLeft: '10px' }}>
              Copy Web URL
            </button>
          </div>
        )}
      </div>

      {/* App URL Section */}
      <div>
        <h3>App URL</h3>
        <p><strong>Default:</strong> {defaultAppUrl}</p>

        <label>WidgetId:</label>
        <input
          type="text"
          value={appWidgetID}
          onChange={(e) => setAppWidgetID(e.target.value)}
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <label>Page Title:</label>
        <input
          type="text"
          value={appTitle}
          onChange={(e) => setAppTitle(e.target.value)}
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <button onClick={handleAppUpdate}>Update App URL</button>

        {modifiedAppUrl && (
          <div style={{ marginTop: '10px' }}>
            <strong>Modified App URL:</strong> 
            <a href={modifiedAppUrl} target="_blank" rel="noopener noreferrer">{modifiedAppUrl}</a>
            <button onClick={() => copyToClipboard(modifiedAppUrl)} style={{ marginLeft: '10px' }}>
              Copy App URL
            </button>
          </div>
        )}
      </div>
    </div>
    
    <div style={{ textAlign: 'center', padding: '20px' }}>
    <h2>Copy Fixed URL</h2>
    <p>{fixedUrl}</p>
    <button onClick={copyToClipboard}>Copy URL</button>
  </div>
    </>
  );
};


// The fixed URL
const fixedUrl = 'https://www.cvs.com/';

// Function to copy the URL to clipboard
const copyToClipboard = () => {
  navigator.clipboard.writeText(fixedUrl);
  alert('Copied to clipboard!');
};


  



export default UrlModifier;
